import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {ParcelsService} from '../../../../services/parcels.service';
import {HistoryItem} from '../../../directory-item/activity/history-item.class';
import {UrlService} from '../../../../services/url.service';

@Component({
    selector: 'history-modal',
    templateUrl: 'history-modal.component.html',
    styleUrls: ['history-modal.component.scss']
})
export class HistoryModalComponent implements OnInit {
    @Input() itemData;
    @Output() onClose = new EventEmitter();
    showModal = false;
    activities: HistoryItem[] = [];

    constructor(
        public parcelsService: ParcelsService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.getActivities();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    getActivities() {
        const url = `/api/v1/history.json?per-page=10000&order-by=loggedAt|desc&objectId=${this.itemData.id}`;
        this.parcelsService.api.get('oauthUrl', url).subscribe(
            res   => this.activities = res.json().map(a => new HistoryItem(a)),
            error => this.parcelsService.api.errorHandler(error, 'Failed get Parcels')
        );
    }

    hideModal() {
        this.onClose.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/history-modal/history-modal.component.ts